function getModule(Settings, Vue, KeenUI, _transform) {
  const ACP = {};

  ACP.init = () => {
    const models = ajaxify.data.models;
    const renderersFromModel = ajaxify.data.renderersFromModel;

    socket.emit('admin.settings.get', {
      hash: 'leech-tool',
    }, (err, settings) => {
      /* eslint no-param-reassign: "off", no-new: "off" */
      // _settings = settings;
      /* vm = */ new Vue({
        el: '.leech-tool-settings',
        data() {
          const prefix = 'rendererFor-';
          const rendererFor = _transform(settings, (result, value, key) => {
            if (key.startsWith(prefix)) {
              result[key.slice(prefix.length)] = value;
            }
          }, {});
          const currModel = models[0];
          return {
            models,
            currModel,
            rendererFor,
            renderers: renderersFromModel[this.currModel],
            currRenderer: rendererFor[currModel],
          };
        },
        computed: {
          settings() {
            // namespacing rendererFor
            const rendererFor = {};
            Object.keys(this.rendererFor).forEach((model) => {
              rendererFor[`rendererFor-${model}`] = this.rendererFor[model];
            });
            return rendererFor;
          },
        },
        methods: {
          reloadRenderers() {
            this.renderers = renderersFromModel[this.currModel];
            this.currRenderer = this.rendererFor[this.currModel] || this.renderers[0];
          },
          updateSelectedRenderer() {
            this.rendererFor[this.currModel] = this.currRenderer;
          },
          saveSettings() {
            socket.emit('admin.settings.set', {
              hash: 'leech-tool',
              values: this.settings,
            }, (saveErr) => {
              /* eslint no-underscore-dangle:"off" */
              // Remove unsaved flag to re-enable ajaxify
              app.flags._unsaved = false;

              // Also save to local ajaxify.data
              ajaxify.data.settings = this.settings;
              if (saveErr) {
                app.alert({
                  title: 'Error while saving settings',
                  type: 'error',
                  timeout: 2500,
                });
              } else {
                app.alert({
                  title: 'Settings Saved',
                  type: 'success',
                  timeout: 2500,
                });
              }
            });
          },
        },
        created() {
          this.reloadRenderers();
        },
        components: {
          'ui-select': KeenUI.UiSelect,
        },
      });
    });
  };

  return ACP;
}

define('admin/plugins/leech-tool', ['settings', 'vue', 'keen-ui', 'lodash/transform'], getModule);
